import React, { useRef, useState } from 'react';

import moment from 'moment-timezone';

export const useTimelineAndDensityLogic = () => {
    const [isShowDensity, setIsShowDensity] = useState<boolean>(true);
    const todayLineRef = useRef<HTMLDivElement | null>(null);
    const mapContainerRef = useRef<HTMLDivElement | null>(null);

    const todayLineDate = moment().valueOf();

    const setTodayLine = (position: number | null) => {
        if (typeof position === 'number' && todayLineRef.current && mapContainerRef.current) {
            todayLineRef.current.style.left = `${position}px`;
            todayLineRef.current.style.height = `${mapContainerRef.current.offsetHeight - 60}px`;
            todayLineRef.current.style.display = 'block';
        }
    };

    const handleShowDensity = (event: React.ChangeEvent<HTMLInputElement>) => {
        const isChecked = event.target.checked;
        setIsShowDensity(isChecked);
    };
    return {
        logic: {
            mapContainerRef,
            todayLineRef,
            isShowDensity,
            handleShowDensity,
            todayLineDate,
            setTodayLine,
        },
    };
};
